import axios from 'axios';

export default {
  resetPassword
};

const URI_RESET_PASSWORD = `/platform-session/api/v1/resetPassword`;

function resetPassword(username) {
  const headers = {
    username: username
  };
  return new Promise((resolve, reject) => {
    axios
      .post(URI_RESET_PASSWORD , {}, {
        headers: headers
      })
      .then(res => resolve(res))
      .catch(error => {
        reject(error);
      });
  });
}



// WEBPACK FOOTER //
// ./src/services/resetPassword/ResetPasswordService.js